<template>
	<div id="app" class="wrapper notranslate">
		<Menu v-if="this.$route.name !== 'Login' || !login" v-show="this.$route.name !== 'Login'"/>
		<!-- <div>
			<div class="logout row text-right" v-if="this.$route.name !== 'Login'">
				<div class="col-12">
					<button class="btn btn-outline-danger" @click="logout"><i class="nc-icon nc-button-power"></i><span>Cerrar Sesion</span></button>
				</div>
			</div>
		</div> -->
		<div :class="{'main-panel': this.$route.name !== 'Login', 'login': this.$route.name === 'Login'}">
			<TopNav v-if="this.$route.name !== 'Login'" />			
			<div class="content">
				<div class="container-fluid">
					<div class="section">
						<router-view/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script >
//import Login from './views/Login.vue'
import TopNav from './components/TopNav.vue';
import Menu from './components/Menu.vue';
import routeService from './services/route_service.js';
import LoginService from './services/login_service.js';
// import Vue from 'vue'
const loginService = new LoginService();
export default {
	name: 'App',
	data: function() {
		return {
			login: true,
		}
	},
	components: { Menu, TopNav},
	beforeUpdate: function () {
		let _this = this;
		if(_this.login == false) {
			return;
		}
		loginService.chkLogin({}).then(function(response) {
			if(response.body && response.body.status && response.body.status == 'success') {
				_this.login = false;
			} else {
				_this.login = true;
			}
		}, function() { 
			_this.login = false;
		});
	},
	methods: {
			logout: function () {
				loginService.logout({}).then(function() {
					routeService.goToLogin();
				}, function() { 
					routeService.goToLogin();
				});
			}
	}
}
</script>

<style>
	@import "./fonts/montesarrat/montesarrat.css";	
	@import "./css/main-layout.css";
	@import "./css/main.css";
</style>
